var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout-fullwidth", [
    _c("div", { staticClass: "marketing-page" }, [
      _c("div", { staticClass: "header-marketing mb-3 mb-md-0" }, [
        _c(
          "div",
          {
            staticClass:
              "header-marketing-text row no-gutters text-center position-relative overflow-hidden",
          },
          [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "row now-gutters my-4 my-lg-5" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "portal.home" } } },
                      [
                        _c("img", {
                          staticClass: "img-fluid",
                          attrs: {
                            alt: "Logo",
                            src: _vm.assetsPathGlobalPlatform("/logo.svg"),
                            width: "140px",
                            height: "120px",
                          },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row now-gutters" }, [
                _c("div", { staticClass: "col-12 col-md-9 col-lg-8 mx-auto" }, [
                  _c("p", { staticClass: "lead" }, [
                    _vm._v("Gerir o município agora é mais fácil"),
                  ]),
                  _vm._v(" "),
                  _c("h2", [
                    _vm._v("Proporcione aos munícipes o melhor do município"),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row now-gutters" }, [
                _c(
                  "div",
                  { staticClass: "col mx-auto" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "portal.contact-us" } } },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-main btn-rounded btn-lg",
                            attrs: { type: "button" },
                          },
                          [_vm._v(_vm._s(_vm.buy))]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row now-gutters header-marketing-img" }, [
          _c(
            "div",
            { staticClass: "col-12 text-center" },
            [
              _c(
                "router-link",
                { attrs: { to: { name: "portal.contact-us" } } },
                [
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: { alt: "", src: _vm.assetsPathModule("/pic-0.png") },
                  }),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "showcase" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "row no-gutters mb-lg-5" }, [
            _c(
              "div",
              { staticClass: "col-12 col-lg-6 mb-3 my-lg-auto showcase-text" },
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "portal.contact-us" } } },
                  [
                    _c("div", { staticClass: "title mb-4" }, [
                      _vm._v("Território"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "heading mb-4" }, [
                  _vm._v("Interaja com o Município através do mapa"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "lead mb-0" }, [
                  _vm._v(
                    "Serviços on-line de base geográfica à disposição da população e das equipas do Município."
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-lg-6 text-white showcase-img d-flex align-items-center justify-content-center",
              },
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "portal.contact-us" } } },
                  [
                    _c("img", {
                      staticClass: "img-fluid",
                      attrs: {
                        alt: "Mapa",
                        src: _vm.assetsPathModule("/pic-1.png"),
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row no-gutters marketing" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-lg-6 order-lg-2 mb-3 my-lg-auto text-white showcase-img d-flex align-items-center justify-content-center",
              },
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "portal.contact-us" } } },
                  [
                    _c("img", {
                      staticClass: "img-fluid",
                      attrs: {
                        alt: "Mapa",
                        src: _vm.assetsPathModule("/pic-4.png"),
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-lg-6 order-lg-1 mb-3 my-lg-auto showcase-text",
              },
              [
                _c("div", { staticClass: "heading mb-4" }, [
                  _vm._v("A app para gestão inteligente do território"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "lead mb-3" }, [
                  _vm._v(
                    "As pessoas vão poder aceder aos serviços sem sair de casa. A gestão e o Município é de todos."
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-5 col-lg-4 px-0" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "portal.contact-us" } } },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-main btn-rounded btn-block btn-md",
                            attrs: { type: "button" },
                          },
                          [_vm._v(_vm._s(_vm.buy))]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row no-gutters" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-lg-7 order-2 order-lg-1 text-white showcase-img d-flex align-items-center justify-content-center",
              },
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "portal.contact-us" } } },
                  [
                    _c("img", {
                      staticClass: "img-fluid",
                      attrs: {
                        alt: "Mapa",
                        src: _vm.assetsPathModule("/pic-2.png"),
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-lg-5 order-1 order-lg-2 mb-3 my-lg-auto showcase-text",
              },
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "portal.contact-us" } } },
                  [
                    _c("div", { staticClass: "title mb-4" }, [
                      _vm._v("Relatórios"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "heading mb-4" }, [
                  _vm._v("Todos os dados disponíveis num só ecrã"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "lead mb-0" }, [
                  _vm._v("Direto, prático, operacional e funcional."),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row no-gutters" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-lg-7 order-2 text-white showcase-img d-flex align-items-center justify-content-center",
              },
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "portal.contact-us" } } },
                  [
                    _c("img", {
                      staticClass: "img-fluid",
                      attrs: {
                        alt: "Mapa",
                        src: _vm.assetsPathModule("/pic-3.png"),
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-lg-5 order-1 order-lg-1 mb-3 my-lg-auto showcase-text",
              },
              [
                _c(
                  "router-link",
                  { attrs: { to: { name: "portal.contact-us" } } },
                  [
                    _c("div", { staticClass: "title mb-4" }, [
                      _vm._v("Personalização"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "heading mb-4" }, [
                  _vm._v("Escalável em função das necessidades de gestão"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "lead mb-0" }, [
                  _vm._v("Ajustado à complexidade das suas operações diárias."),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("footer", { staticClass: "footer-marketing" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "row m-sm-0 p-sm-0" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-md-auto d-flex flex-sm-column align-items-sm-start justify-content-between",
              },
              [
                _c("img", {
                  staticClass: "img-fluid img-logo",
                  attrs: {
                    alt: "Logo",
                    src: _vm.assetsPathGlobalPlatform("/logo-1.svg"),
                  },
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "d-none d-sm-block",
                    attrs: {
                      href: "https://www.municipia.pt",
                      target: "_blank",
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "img-fluid img-municipia",
                      attrs: { alt: "Municipia", src: _vm.LogoIcon },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "d-block d-sm-none",
                    attrs: { to: { name: "portal.contact-us" } },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-main btn-rounded btn-sm my-0",
                        attrs: { type: "button" },
                      },
                      [_vm._v(_vm._s(_vm.buy))]
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md mx-auto" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-sm-9 col-lg-7 mx-auto" },
                  [
                    _c("p", [
                      _vm._v(
                        "Plataforma centralizadora de soluções digitais que, através da localização, permite ao munícipe aceder a serviços sem sair de casa e ao município garantir a prestação de serviços à população com melhor qualidade e celeridade."
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        staticClass: "d-none d-sm-block",
                        attrs: { to: { name: "portal.contact-us" } },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-main btn-rounded btn-sm mx-0",
                            attrs: { type: "button" },
                          },
                          [_vm._v(_vm._s(_vm.buy))]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-auto" }, [
              _c("div", {}, [
                _c("ul", { staticClass: "list list-unstyled font-small" }, [
                  _c("li", { staticClass: "list-item" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.municipia.pt",
                          target: "_blank",
                        },
                      },
                      [_vm._v("Sobre a municípia")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "list-item" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "portal.contact-us" } } },
                        [
                          _vm._v(
                            "\n                                    Contatos\n                                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 d-sm-none text-center" }, [
              _c(
                "a",
                {
                  attrs: { href: "https://www.municipia.pt", target: "_blank" },
                },
                [
                  _c("img", {
                    staticClass: "img-fluid img-municipia small",
                    attrs: { alt: "Municipia", src: _vm.LogoIcon },
                  }),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }